function Wrapper ({children,className}) {
    return (
        <section className={`max-w-[1410px] w-[95%] mx-auto ${className}`}>
            {children}
        </section>
    )
}

export {Wrapper}
